import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse, Table} from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaEdit, FaMapMarkerAlt, FaSlash, FaDrawPolygon, FaRegCircle, FaRegSquare } from 'react-icons/fa';
import uuid from 'react-uuid';
import './Cropping.css';
const CropAreaItemView = ({ cropAreaItem, cropAreaRecordItems, handleItemEditPopup, handleCropRecordPopupOpen, handleCropRecordPopupEdit, handleItemHighlight }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const handleItemExpandCollapse = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    return (
        <Row>
            <Col>
                <Card className="my-3">
                    <CardHeader className="item-header item_click" onClick={handleItemExpandCollapse}>
                        <Row>
                            <Col sm="1">
                                <a onMouseOver={(itemId) => handleItemHighlight(cropAreaItem.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                                    {cropAreaItem.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={cropAreaItem.colour}></FaMapMarkerAlt> :
                                        cropAreaItem.mapMarkerType == 'polyline' ? <FaSlash color={cropAreaItem.colour}></FaSlash> :
                                            cropAreaItem.mapMarkerType == 'polygon' ? <FaDrawPolygon color={cropAreaItem.colour}></FaDrawPolygon> :
                                                cropAreaItem.mapMarkerType == 'circle' ? <FaRegCircle color={cropAreaItem.colour}></FaRegCircle> :
                                                    cropAreaItem.mapMarkerType == 'rectangle' && <FaRegSquare color={cropAreaItem.colour}></FaRegSquare>}
                                </a>
                            </Col>
                            <Col sm="5"><h6 className="text-uppercase">{cropAreaItem.name}</h6></Col>
                            <Col sm="5" className="text-end">
                                <Button style={{ marginRight: "20px" }} color="primary" size="sm" onClick={(itemId) => handleItemEditPopup(cropAreaItem.itemId)}>
                                    Edit
                                </Button>
                                <Button style={{ marginRight: "20px" }} color="warning" size="sm" onClick={(itemId) => handleCropRecordPopupOpen(cropAreaItem.itemId)}>
                                    Add Crop Record
                                </Button>
                            </Col>
                            <Col sm="1" className="text-end toggleoutline">
                                {
                                    isIconUp ?
                                        <FaChevronUp /> :
                                        <FaChevronDown />
                                }
                            </Col>
                        </Row>

                    </CardHeader>
                    <Collapse isOpen={isOpen}>
                        <CardBody>
                            <Row className="my-3">
                                <Col>
                                    <Table bordered>
                                        <thead style={{textAlign:"center"}}>
                                            <tr key={uuid()}>
                                                <th style={{ width: "5%" }}> Edit </th>
                                                <th style={{ width: "5%" }}> Year </th>
                                                <th style={{ width: "10%" }}> Crop</th>
                                                <th style={{ width: "10%" }}> Crop Yield (TDM/ ha) </th>
                                                <th style={{ width: "20%" }}> Month Sown </th>
                                                <th style={{ width: "20%" }}> Month Harvested </th>
                                                <th style={{ width: "10%" }}> Cultivation Method</th>
                                                <th style={{ width: "20%", textAlign: "left" }}> Mitigations in place to reduce runoff</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ textAlign: "center" }}>
                                            {cropAreaRecordItems != undefined && cropAreaRecordItems != null && cropAreaRecordItems.map((item, idx) => (
                                                <tr key={uuid()}>
                                                    <td style={{ width: "5%" }}><button type="button"
                                                        onClick={(itemId) => handleCropRecordPopupEdit(item.id,cropAreaItem.itemId)}
                                                        className="btn btn-sm btn-edit">
                                                        <FaEdit />
                                                    </button></td>
                                                    <td style={{ width: "5%" }}>{item.yearValue}</td>
                                                    <td style={{ width: "10%" }}>{item.cropTypeText}</td>
                                                    <td style={{ width: "10%" }}>{item.cropYield}</td>
                                                    <td style={{ width: "20%" }}>{item.monthSown}</td>
                                                    <td style={{ width: "20%" }}>{item.monthsGrazedHarvested }</td>
                                                    <td style={{ width: "10%" }}>{item.cultivationMethodText}</td>
                                                    <td style={{ width: "20%", fontSize: "11px", textAlign: "left" }}>{item.mitigationsToReduceSedimentSoilRunoff}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </CardBody>
                    </Collapse>
                </Card>
            </Col>
        </Row>
        )
}
export default CropAreaItemView;